/* export const customers = [
    { 
        id: 'CUST-101', 
        fullName: 'John Doe',
        dateOfBirth: '1985-05-20',
        address: '123 Maple St, Anytown, USA',
        nationality: 'USA',
        occupation: 'Used Car Dealer',
        riskRating: 'High',
        riskBreakdown: { kycScore: 45, txnScore: 40, total: 85, events: [ { date: '2025-08-27', description: 'Initial High Risk', impact: 40 } ] },
        onboardingDate: '2022-01-15',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['High-Risk-Industry'] },
        sharedIdentifiers: { phone: '555-123-4567' } // New Field

    },
    { 
        id: 'CUST-102', 
        fullName: 'Jane Smith',
        dateOfBirth: '1992-11-30',
        address: '456 Oak Ave, Anytown, USA',
        nationality: 'CAN',
        occupation: 'Software Engineer',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 5, total: 15, events: [] },
        onboardingDate: '2023-03-10',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['New-Customer'] },
        sharedIdentifiers: { phone: '555-888-9999' }

    },
    { 
        id: 'CUST-103', 
        fullName: 'Global Corp.',
        dateOfBirth: null,
        address: '789 Pine Ln, Business City, USA',
        nationality: 'USA',
        occupation: 'International Trade',
        riskRating: 'High',
        riskBreakdown: { kycScore: 35, txnScore: 60, total: 95, events: [ { date: '2025-08-28', description: 'Sanctions Match Activity', impact: 60 } ] },
        onboardingDate: '2021-06-21',
        customFields: { watchlistTag: 'Sanctions Match', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'GC-4592' }

    },
    { 
        id: 'CUST-104', 
        fullName: 'Local Traders',
        dateOfBirth: null,
        address: '101 Birch Rd, Anytown, USA',
        nationality: 'USA',
        occupation: 'Retail',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 15, txnScore: 30, total: 45, events: [] },
        onboardingDate: '2022-09-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '555-123-4567' } 
    },
]; */

export const customers = [
    // --- High-Risk (5 profiles) ---
    { 
        id: 'CUST-101', 
        fullName: 'Khaled Al-Fahd',
        dateOfBirth: '1982-07-15',
        address: '123 King Fahd Rd, Riyadh, KSA',
        nationality: 'SAU',
        occupation: 'Real Estate Developer',
        riskRating: 'High',
        riskBreakdown: { kycScore: 50, txnScore: 35, total: 85, events: [] },
        onboardingDate: '2022-02-10',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['High-Net-Worth'] },
        sharedIdentifiers: { phone: '+966-50-123-4567' }
    },
    { 
        id: 'CUST-102', 
        fullName: 'Jeddah General Trading LLC',
        dateOfBirth: null,
        address: '789 Corniche Rd, Jeddah, KSA',
        nationality: 'SAU',
        occupation: 'International Trade',
        riskRating: 'High',
        riskBreakdown: { kycScore: 40, txnScore: 55, total: 95, events: [] },
        onboardingDate: '2021-05-18',
        customFields: { watchlistTag: 'Sanctions Match', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'CR-12345', address: 'PO Box 101, Jeddah' }
    },
    { 
        id: 'CUST-103', 
        fullName: 'Hassan Ibrahim',
        dateOfBirth: '1979-01-01',
        address: 'Olaya St, Riyadh, KSA',
        nationality: 'SAU',
        occupation: 'Precious Metals Dealer',
        riskRating: 'High',
        riskBreakdown: { kycScore: 60, txnScore: 20, total: 80, events: [] },
        onboardingDate: '2022-03-12',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-50-123-4567' } // Shares phone with Khaled Al-Fahd
    },
    { 
        id: 'CUST-104', 
        fullName: 'Dubai Investment Holdings',
        dateOfBirth: null,
        address: 'DIFC, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Private Equity Firm',
        riskRating: 'High',
        riskBreakdown: { kycScore: 55, txnScore: 40, total: 95, events: [] },
        onboardingDate: '2020-11-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'DXB-9876' }
    },
    { 
        id: 'CUST-105', 
        fullName: 'Abdullah bin Nasser',
        dateOfBirth: '1965-04-12',
        address: 'Diplomatic Quarter, Riyadh, KSA',
        nationality: 'SAU',
        occupation: 'Government Official',
        riskRating: 'High',
        riskBreakdown: { kycScore: 70, txnScore: 15, total: 85, events: [] },
        onboardingDate: '2019-09-05',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'Yes - Tier 1', tags: ['PEP'] },
        sharedIdentifiers: { email: 'a.nasser@gov.sa' }
    },

    // --- Medium-Risk (10 profiles) ---
    { 
        id: 'CUST-201', 
        fullName: 'Fatima Al-Mansoori',
        dateOfBirth: '1990-03-22',
        address: '456 Sheikh Zayed Rd, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Oil & Gas Executive',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 30, txnScore: 25, total: 55, events: [] },
        onboardingDate: '2023-01-20',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+971-55-987-6543' }
    },
    { 
        id: 'CUST-202', 
        fullName: 'Arabian Logistics Solutions',
        dateOfBirth: null,
        address: 'Dammam Port, Dammam, KSA',
        nationality: 'SAU',
        occupation: 'Logistics Company',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 25, txnScore: 40, total: 65, events: [] },
        onboardingDate: '2021-08-11',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'CR-67890' }
    },
    { 
        id: 'CUST-203', 
        fullName: 'Maria Petrova', // Expat
        dateOfBirth: '1988-12-01',
        address: 'JLT, Dubai, UAE',
        nationality: 'RUS',
        occupation: 'Marketing Director',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 40, txnScore: 20, total: 60, events: [] },
        onboardingDate: '2022-07-25',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-52-333-4444' }
    },
    { 
        id: 'CUST-204', 
        fullName: 'Luxury Auto Imports FZE',
        dateOfBirth: null,
        address: 'Jebel Ali Free Zone, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Luxury Goods Dealer',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 35, txnScore: 35, total: 70, events: [] },
        onboardingDate: '2020-02-14',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'DXB-5432' }
    },
    { 
        id: 'CUST-205', 
        fullName: 'Ahmed Al-Jaber',
        dateOfBirth: '1975-06-18',
        address: 'Khalifa City, Abu Dhabi, UAE',
        nationality: 'ARE',
        occupation: 'Construction Contractor',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 30, txnScore: 30, total: 60, events: [] },
        onboardingDate: '2021-11-20',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+971-50-555-1212' }
    },
    { 
        id: 'CUST-206', 
        fullName: 'Yusuf Mohamed',
        dateOfBirth: '1983-09-03',
        address: 'Tahlia Street, Jeddah, KSA',
        nationality: 'EGY',
        occupation: 'Restaurant Owner',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 20, txnScore: 25, total: 45, events: [] },
        onboardingDate: '2022-05-15',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-53-222-1111' }
    },
    { 
        id: 'CUST-207', 
        fullName: 'Riyadh IT Services Co.',
        dateOfBirth: null,
        address: 'Digital City, Riyadh, KSA',
        nationality: 'SAU',
        occupation: 'IT Services Company',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 15, txnScore: 30, total: 45, events: [] },
        onboardingDate: '2023-02-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'CR-11223' }
    },
    { 
        id: 'CUST-208', 
        fullName: 'Noura Al-Ketbi',
        dateOfBirth: '1989-02-28',
        address: 'Alserkal Avenue, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Art Dealer',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 40, txnScore: 25, total: 65, events: [] },
        onboardingDate: '2021-10-09',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { email: 'noura.gallery@art.ae' }
    },
    { 
        id: 'CUST-209', 
        fullName: 'Chen Wei', // Expat
        dateOfBirth: '1978-08-20',
        address: 'International City, Dubai, UAE',
        nationality: 'CHN',
        occupation: 'Manufacturing Manager',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 25, txnScore: 20, total: 45, events: [] },
        onboardingDate: '2022-04-11',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-56-789-0123' }
    },
    { 
        id: 'CUST-210', 
        fullName: 'Emirates Travel & Tours LLC',
        dateOfBirth: null,
        address: 'Business Bay, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Travel Agency',
        riskRating: 'Medium',
        riskBreakdown: { kycScore: 20, txnScore: 35, total: 55, events: [] },
        onboardingDate: '2019-12-10',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'DXB-7788', address: 'PO Box 101, Jeddah' } // Shares address with CUST-102
    },

    // --- Low-Risk (15 profiles) ---
    { 
        id: 'CUST-301', 
        fullName: 'Richard Thompson', // Expat
        dateOfBirth: '1985-11-05',
        address: 'Marina Gate, Dubai, UAE',
        nationality: 'GBR',
        occupation: 'IT Consultant',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 10, total: 15, events: [] },
        onboardingDate: '2022-10-30',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-52-111-2222' }
    },
    { 
        id: 'CUST-302', 
        fullName: 'Aisha Al-Nuaimi',
        dateOfBirth: '1995-05-10',
        address: 'Al Barsha, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Teacher',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 5, total: 10, events: [] },
        onboardingDate: '2023-04-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+971-50-123-7890' }
    },
    { 
        id: 'CUST-303', 
        fullName: 'Dr. Mohammed Abdullah',
        dateOfBirth: '1970-02-25',
        address: 'King Abdullah Medical City, Jeddah, KSA',
        nationality: 'SAU',
        occupation: 'Doctor',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 15, total: 20, events: [] },
        onboardingDate: '2018-06-15',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-55-444-3333' }
    },
    { 
        id: 'CUST-304', 
        fullName: 'Anil Kumar', // Expat
        dateOfBirth: '1991-07-19',
        address: 'Bur Dubai, Dubai, UAE',
        nationality: 'IND',
        occupation: 'Accountant',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 10, total: 20, events: [] },
        onboardingDate: '2022-11-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-55-666-7777' }
    },
    { 
        id: 'CUST-305', 
        fullName: 'Dubai Blooms Flower Shop',
        dateOfBirth: null,
        address: 'Jumeirah, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Retail',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 15, total: 25, events: [] },
        onboardingDate: '2021-02-20',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'DXB-1010' }
    },
    { 
        id: 'CUST-306', 
        fullName: 'Prof. Saud Al-Rajhi',
        dateOfBirth: '1968-10-10',
        address: 'KAUST, Thuwal, KSA',
        nationality: 'SAU',
        occupation: 'University Professor',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 5, total: 10, events: [] },
        onboardingDate: '2017-09-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { email: 's.rajhi@uni.edu.sa' }
    },
    { 
        id: 'CUST-307', 
        fullName: 'Emily Jones', // Expat
        dateOfBirth: '1993-04-14',
        address: 'The Greens, Dubai, UAE',
        nationality: 'AUS',
        occupation: 'Graphic Designer',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 5, total: 10, events: [] },
        onboardingDate: '2023-03-15',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-50-999-8888' }
    },
    { 
        id: 'CUST-308', 
        fullName: 'Jeddah Book Emporium',
        dateOfBirth: null,
        address: 'Al-Balad, Jeddah, KSA',
        nationality: 'SAU',
        occupation: 'Retail',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 10, total: 20, events: [] },
        onboardingDate: '2020-07-07',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'CR-55555' }
    },
    { 
        id: 'CUST-309', 
        fullName: 'Omar Sharif',
        dateOfBirth: '1980-12-12',
        address: 'Al Hamra, Jeddah, KSA',
        nationality: 'EGY',
        occupation: 'Chef',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 15, txnScore: 10, total: 25, events: [] },
        onboardingDate: '2022-08-08',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-50-321-6547' }
    },
    { 
        id: 'CUST-310', 
        fullName: 'Layla Murad',
        dateOfBirth: '1996-06-06',
        address: 'Healthcare City, Dubai, UAE',
        nationality: 'ARE',
        occupation: 'Pharmacist',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 5, total: 10, events: [] },
        onboardingDate: '2023-05-25',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { email: 'layla.m@pharma.ae' }
    },
    { 
        id: 'CUST-311', 
        fullName: 'Faris Al-Ghamdi',
        dateOfBirth: '1981-03-03',
        address: 'Al Khobar, KSA',
        nationality: 'SAU',
        occupation: 'Pilot',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 15, total: 25, events: [] },
        onboardingDate: '2019-05-19',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-50-777-9999' }
    },
    { 
        id: 'CUST-312', 
        fullName: 'Sophie Dubois', // Expat
        dateOfBirth: '1990-10-25',
        address: 'Downtown Dubai, UAE',
        nationality: 'FRA',
        occupation: 'Hotel Manager',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 10, total: 20, events: [] },
        onboardingDate: '2022-12-01',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: ['Expat'] },
        sharedIdentifiers: { phone: '+971-56-123-4567' }
    },
    { 
        id: 'CUST-313', 
        fullName: 'Al Khobar Cafe',
        dateOfBirth: null,
        address: 'Corniche, Al Khobar, KSA',
        nationality: 'SAU',
        occupation: 'Restaurant Owner',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 15, txnScore: 15, total: 30, events: [] },
        onboardingDate: '2021-04-16',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { registrationId: 'CR-78912' }
    },
    { 
        id: 'CUST-314', 
        fullName: 'Sultan Al-Otaibi',
        dateOfBirth: '1987-07-07',
        address: 'Al Malaz, Riyadh, KSA',
        nationality: 'SAU',
        occupation: 'Engineer',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 5, txnScore: 10, total: 15, events: [] },
        onboardingDate: '2020-10-10',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+966-55-888-7777' }
    },
    { 
        id: 'CUST-315', 
        fullName: 'Reem Khalil',
        dateOfBirth: '1992-09-09',
        address: 'Al Nahda, Sharjah, UAE',
        nationality: 'JOR',
        occupation: 'Architect',
        riskRating: 'Low',
        riskBreakdown: { kycScore: 10, txnScore: 10, total: 20, events: [] },
        onboardingDate: '2022-06-22',
        customFields: { watchlistTag: 'None', politicallyExposedPerson: 'No', tags: [] },
        sharedIdentifiers: { phone: '+971-50-234-5678' }
    },
];